import Vue from "vue";
import Vuex from "vuex";
import config from "/config";
import packages from "../modules";

// Main
import Api from "./api";
import utils from "./utils";

// Packages

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        utils: new utils(),
        config: config,
        api: Api,
        // devEnv: window.location.origin.includes('192.168'),
        devEnv: false,
        modules: {
            api: packages.api,
            account: {
                user: undefined,
                token: undefined
            },
        },
    }
});
